import React, { Component } from 'react';
import { Dialog, Grid, DialogContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Close from '@material-ui/icons/Close';
import { imageLocation } from '../config/constants';
import '../style/projectDialog.css';
export class ProjectDialog extends Component {
	state = {
		fade: 'in'
	};

	fade(image) {
		if (this.state.image !== image) {
			this.props.fadeOut();
			setTimeout(() => this.props.setImage(image), 500);
		}
	}

	render() {
		return (
			<Dialog
				fullScreen
				disableBackdropClick
				open={this.props.open}
				onClose={this.props.close}
				BackdropProps={{ style: { opacity: 0.8, backgroundColor: 'black' } }}
				PaperProps={{
					style: {
						backgroundColor: 'transparent',
						boxShadow: 'none',
						height: '100vh'
					}
				}}
			>
				{this.props.image ? (
					<DialogContent
						style={{ padding: '0', height: '100%' }}
						className="projectDialog"
						disableBackdropClick={true}
					>
						<Grid container spacing={0} direction="row" style={{ width: '100%' }}>
							<Grid item xs={10}>
								<div style={{ position: 'relative', width: '100%', height: '80vh' }}>
									<img
										align="right"
										alt={this.props.image + console.log(`${imageLocation}projects/${this.props.image.replace(/ /g, '%20')})`)}
										src={`${imageLocation}projects/${this.props.image.replace(/ /g, '%20').toLowerCase()}`}
										className={`dialogImage fade${this.props.fade}`}
										style={{
											maxHeight: '80vh'
										}}
									/>
									<Close
										style={{
											cursor: 'pointer',
											zIndex: 1000,
											position: 'absolute',
											right: 0,
											top: 0
										}}
										onClick={this.props.close}
									/>
								</div>
								<div style={{ fontSize: '1.3em', width: '100%', textAlign: 'right' }}>
									{this.props.project.name}
								</div>
							</Grid>
							<Grid item xs={2}>
								<div className="slideshow">
									<ul>
										{this.props.image &&
											this.props.project.images.map((image, idx) => (
												<li
													key={'img' + idx}
													className="preview"
													style={{
														backgroundImage:
															`url(${imageLocation}projects/${image.name.replace(/ /g, '%20').toLowerCase()})`,
														marginLeft: '2px'
													}}
													onClick={() => this.fade(image.name)}
												/>
											))}
									</ul>
								</div>
							</Grid>
						</Grid>
					</DialogContent>
				) : (
					<div />
				)}
			</Dialog>
		);
	}
}

export class MobileProjectDialog extends ProjectDialog {
	render() {
		return (
			<Dialog
				fullScreen
				disableBackdropClick
				open={this.props.open}
				onClose={this.props.close}
				BackdropProps={{ style: { opacity: 0.8, backgroundColor: 'black' } }}
				PaperProps={{
					style: {
						backgroundColor: 'transparent',
						boxShadow: 'none',
						height: '100vh'
					}
				}}
			>
				{this.props.image ? (
					<div>
						<div
							className="projectName"
							style={{
								zIndex: 2000,
								left: '0px',
								bottom: '0px',
								position: 'fixed',
								fontSize: '20px'
							}}
						>
							<Close onClick={this.props.close} />
							{this.props.project.name}
						</div>
						<DialogContent
							style={{ padding: '0', height: '100%' }}
							className="mobileProjectDialog"
							disableBackdropClick={true}
						>
							<img
								alt={this.props.image}
                                src={`${imageLocation}projects/${this.props.image.replace(/ /g, '%20')}`}
								className={`dialogImage fade${this.props.fade}`}
							/>
							<div className="slideshow">
								<ul>
									{this.props.image &&
										this.props.project.images.map((image, idx) => (
											<li
												key={'img' + idx}
												className="preview"
												style={{
													backgroundImage:
                                                        `url(${imageLocation}projects/${image.name.replace(/ /g, '%20')})`,
													marginLeft: '2px'
												}}
												onClick={() => this.fade(image.name)}
											/>
										))}
								</ul>
							</div>
						</DialogContent>
					</div>
				) : (
					<div />
				)}
			</Dialog>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/projectDialog.js